/**
 * Created by akrio on 2018/3/23.
 */
import {
  login as loginRes,
  delPubliships as delPublishipRes,
  mulModifyUnlimited as mulModifyUnlimitedRes,
  publisherInfo as publisherInfoRes,
  getMemberUserContent as getMemberUserContentRes,
  getAdminUserContent as getAdminUserContentRes,
  delMemberUserContent,
  delAdminUserContent,
  updateMemberUserContent,
  updateAdminUserContent,
  createAdminUserContent,
  createMemberUserContent,
  mulUpdateMemberUserContent,
  mulUpdateAdminUserContent,
  updateAdminPublisher,
  updateMemberPublisher,
  publishipsFacebook as publishipsFacebookRes,
  publishipsTwitter as publishipsTwitterRes,
} from "../api/publisher";
import { updateUserInfo } from "../service/user";
import { publisherDetail } from "../api/instagram";
import app from "../main";
import { Publisher } from "./model/user";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE,
  CURRENT_USER_INFO,
  PUBLISHER_CAPTION_COMMENT_LIST,
  CURRENT_PUBLISHER_ID,
} from "../store/mutation-types";
import store from "../store/index";
import { randomNum } from "../utils";
import _ from "lodash";
import { initValidate } from "../utils/errors";
import {
  requestToken as requestTokenRes,
  accessToken as accessTokenRes,
} from "../api/facebook";

export async function requestToken({ callbackUrl }) {
  const { data } = await requestTokenRes({ callback_url: callbackUrl });
  return data;
}
export async function accessToken({ oauthVerifier }) {
  const { data } = await accessTokenRes({ oauth_verifier: oauthVerifier });
  return data;
}

/**
 * 绑定twitter
 * @param access_token 接口返回的access_token
 * @param access_token_secret 接口返回的access_token_secret
 */
export async function publishipsTwitter({ access_token, access_token_secret }) {
  const { data } = await publishipsTwitterRes({
    publisher_access_token: access_token,
    publisher_access_token_secret: access_token_secret,
  });
  await updateUserInfo({});
  return data;
}
/**
 * 绑定facebook
 * @param social_user_token Facebook user access token
 * @param selected_ids 用户选择的 Facebook group id，以逗号分隔。仅当添加/验证 Facebook group 时需要。
 * @param social_network 2 - Facebook Page 3 - Facebook Group
 */
export async function publishipsFacebook({
  social_user_token,
  selected_ids,
  social_network = 2,
  publisherId = null,
  homeLogin = false,
}) {
  const { data } = await publishipsFacebookRes({
    social_user_token,
    selected_ids,
    social_network,
  });
  // 判断当前指定项是否添加成功
  const success = data.publiships.find((p) => p.publisher.id === publisherId);
  await updateUserInfo({});
  if (success && publisherId) {
    store.commit(CURRENT_PUBLISHER_ID, publisherId);
  } else {
    if (data.failure_message) {
      let alertMsg = data.failure_message;
      const msgs = data.failure_message.split("\n\n");
      if (msgs.length === 2) {
        alertMsg = `<b>${msgs[0]}</b>\n\n${msgs[1]}`;
      }
      if (homeLogin && data.publiships.length > 0) {
        store.commit(CURRENT_PUBLISHER_ID, data.publiships[0].publisher.id);
      }
      throw initValidate({
        msg: `<p style="white-space: pre-wrap;">${alertMsg}</p>`,
        code: 1,
      });
    } else {
      if (homeLogin) {
        store.commit(CURRENT_PUBLISHER_ID, data.publiships[0].publisher.id);
      }
    }
  }
  return data;
}
/**
 * publisher用户登录
 * @param username 用户名
 * @param password 密码(选填)
 */
export async function login({ username, password = undefined }) {
  const { data } = await loginRes({ username, password });
  await updateUserInfo({});
  return data;
}

/**
 * 删除当前 Publiship
 */
export async function remove({ id }) {
  // 调取删除接口
  const { data } = await delPublishipRes({ pk: id });
  await updateUserInfo({});
  return data;
}

/**
 * 批量绑定unlimited 用户
 * @param ids 用户id
 * @param is_premium 是否限制为unlimted用户
 * @returns {*}
 */
export async function mulModifyUnlimited({ ids, isPremium = true }) {
  const { data } = await mulModifyUnlimitedRes({
    ids: ids.toString(),
    is_premium: isPremium,
  });
  await updateUserInfo({});
  return data;
}

/**
 * 修改publisher 对应信息
 * @param id publisher 对应id
 * @param notification 待处理的通知开关信息
 * @returns {Promise<void>}
 */
export async function updatePublisherNotification({
  publisherId,
  notification,
}) {
  // 对开关进行处理
  let email_notification_select = [];
  let push_notification_select = [];
  if (notification.emailPostStatus) {
    email_notification_select.push(2);
  }
  if (notification.emailFailureAlert) {
    email_notification_select.push(3);
  }
  if (notification.pushDailyAnalyticsReport) {
    push_notification_select.push(1);
  }
  if (notification.pushPostStatus) {
    push_notification_select.push(2);
  }
  if (notification.pushFailureAlert) {
    push_notification_select.push(3);
  }
  const { data } = await updatePublisher({
    publisherId,
    email_notification_select: email_notification_select.toString(),
    push_notification_select: push_notification_select.toString(),
  });
  await updateUserInfo({});
  return data;
}

/**
 * 如果用户没有相应权限则弹出提示
 * @param type 验证的权限类型
 * @returns {Promise<void>}
 */
export async function permissionValidate({ type }) {
  if (type === "full") {
    await app.$confirm.show({
      title: "Plus, Pro, Team, Business Only",
      text: "Your free trial of this advanced feature has ended. Please upgrade to Plus, Pro, Team or Business Plan to unlock the feature.",
      yesText: "Upgrade",
      cancelText: "Later",
    });
  } else if (type === "pro") {
    await app.$confirm.show({
      title: "Pro, Team, Business Only",
      text: "Your free trial of this advanced feature has ended. Please upgrade to Pro, Team or Business Plan to unlock the feature.",
      yesText: "Upgrade",
      cancelText: "Later",
    });
  } else if (type === "basic") {
    await app.$confirm.show({
      title: "Upgrade Plan",
      text: "Your free trial of this advanced feature has ended.",
      yesText: "Upgrade",
      cancelText: "Later",
    });
  }
  app.$router.push({ name: "UpgradePage" });
  app.$bus.$emit("closeAll");
}

/**
 * 获取登录人的publisher信息
 */
export async function getPublisherInfo() {
  const { data } = await publisherInfoRes();
  return new Publisher({ publisher: data });
}
/**
 * 获取当前ins用户基础信息
 * @returns
 */
export async function getCurrentPublisherInfo() {
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  const { data } = await publisherDetail({
    accessToken: currentPublisher.userToken,
    uid: currentPublisher.socialUid,
  });
  return data;
}
/**
 * 验证当前publisher是否需要重新登录
 */
export function validateCurrentPublisherStatus(autoSwitch) {
  // 获取当前选中的publisher
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  if (user.linkedInstagramList.length > 0) {
    const status = user.linkedInstagramList.find(
      (l) => l.publisherId === currentPublisher.publisherId
    ).status;
    // 验证当前用户是否是否需要重新登录
    if (
      currentPublisher !== null &&
      app.$route.name !== "LoginPage" &&
      (status === 0 || status === 2)
    ) {
      if (currentPublisher.socialNetwork === 1) {
        const params = {
          username: currentPublisher.username,
          insType: "verify",
          message: "Use Apphi APP on your phone to login.",
          autoSwitch,
        };
        app.$bus.$emit("showAddIns", params);
      } else if (currentPublisher.socialNetwork === 2) {
        app.$bus.$emit("showAddFacebookPage", {
          publisherId: currentPublisher.publisherId,
        });
      } else if (currentPublisher.socialNetwork === 3) {
        this.$bus.$emit("showAddFacebookGroup", {
          publisherId: currentPublisher.publisherId,
        });
      } else if (currentPublisher.socialNetwork === 4) {
        this.$bus.$emit("showAddTwitter", {
          publisherId: currentPublisher.publisherId,
        });
      }
      return false;
    }
  }
  return true;
}

/**
 * 获取指定publisher content
 * @param publisherId
 * @param type
 */
export async function getUserContent({ publisherId, type }) {
  let content_type = type === "caption" ? 1 : 2;
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const publisher = user.linkedInstagramList.find(
    (link) => link.publisherId === publisherId
  );
  let data;
  // 如果是查询的member类型则调用member接口 反之调取admin接口
  if (publisher.isMember) {
    data = await getMemberUserContentRes({
      publiship_id: publisher.id,
      member_id: publisher.memberId,
      content_type,
    });
  } else {
    data = await getAdminUserContentRes({
      publiship_id: publisher.id,
      content_type,
    });
  }
  data.data.forEach((item) => {
    item.del = false; // 主要用于标记将要删除的项
  });
  // 格式化数据将saved拆出
  return data.data;
}

/**
 * 删除 content
 * @param publisherId
 * @param 删除的id 数组类型
 */
export async function delUserContent({ publisherId, ids }) {
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const publisher = user.linkedInstagramList.find(
    (link) => link.publisherId === publisherId
  );
  const params = {
    publiship_id: publisher.id,
    ids: ids.toString(),
  };
  let data;
  // 如果是查询的member类型则调用member接口 反之调取admin接口
  if (publisher.isMember) {
    params.member_id = publisher.memberId;
    data = await delMemberUserContent(params);
  } else {
    data = await delAdminUserContent(params);
  }
  return data;
}

/**
 * 修改user content
 * @param publisherId 所选人对应id
 * @param id 修改表单对应id
 * @param form 修改的表单
 * @returns {Promise<void>}
 */
export async function updateUserContent({ publisherId, ids, form }) {
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const publisher = user.linkedInstagramList.find(
    (link) => link.publisherId === publisherId
  );
  const params = {
    publiship_id: publisher.id,
    id: ids[0],
    form,
  };
  let data;
  // 如果是查询的member类型则调用member接口 反之调取admin接口
  if (publisher.isMember) {
    params.member_id = publisher.memberId;
    data = await updateMemberUserContent(params);
  } else {
    data = await updateAdminUserContent(params);
  }
  return data.data;
}

/**
 * 创建user content
 * @param publisherId 所选人对应id
 * @param form 修改的表单
 * @returns {Promise<void>}
 */
export async function createUserContent({ publisherId, form }) {
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const publisher = user.linkedInstagramList.find(
    (link) => link.publisherId === publisherId
  );
  const params = {
    publiship_id: publisher.id,
    form,
  };
  let data;
  // 如果是查询的member类型则调用member接口 反之调取admin接口
  if (publisher.isMember) {
    params.member_id = publisher.memberId;
    data = await createMemberUserContent(params);
  } else {
    data = await createAdminUserContent(params);
  }
  return data.data;
}

/**
 *  批量修改user content
 * @param publisherId 所选人对应id
 * @param form 修改的表单
 * @returns {Promise<void>}
 */
export async function mulUpdateUserContent({ publisherId, form }) {
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const publisher = user.linkedInstagramList.find(
    (link) => link.publisherId === publisherId
  );
  const params = {
    publiship_id: publisher.id,
    form,
  };
  // 可能存在冗余字段del 直接删除
  form.forEach((i) => {
    delete i.del;
  });
  let data;
  // 如果是查询的member类型则调用member接口 反之调取admin接口
  if (publisher.isMember) {
    params.member_id = publisher.memberId;
    data = await mulUpdateMemberUserContent(params);
  } else {
    data = await mulUpdateAdminUserContent(params);
  }
  return data.data;
}

/**
 * 更新指定publisher
 * @param params
 * @return {Promise<void>}
 */
export async function updatePublisher(params) {
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const publisher = user.linkedInstagramList.find((link) => {
    if (params.id) {
      return link.id === params.id;
    } else if (params.publisherId) {
      return link.publisherId === params.publisherId;
    }
  });
  let data;
  params.id = publisher.id;
  if (publisher.isMember) {
    params.member_id = publisher.memberId;
    data = await updateMemberPublisher({ ...params, id: publisher.id });
  } else {
    data = await updateAdminPublisher({ ...params, id: publisher.id });
  }
  // 如果info信息发生改变则更新当前登录人指定publisher信息
  const loginUser = store.getters[CURRENT_USER_INFO];
  const publisherIndex = loginUser.publiships.findIndex(
    (p) => p.id === publisher.id
  );
  loginUser.publiships[publisherIndex] = data.data;
  store.commit(CURRENT_USER_INFO, loginUser);
  return data;
}

/**
 * 保存publisher的caption comment
 * @param publisherId 指定的publisher
 * @param caption 指定caption 不从服务器请求
 * @param comment 指定comment 不从comment请求
 */
export async function setCurrentPublisherCommentCaption({
  caption,
  comment,
  publisherId,
}) {
  if (!publisherId) {
    publisherId = store.getters[CURRENT_PUBLISHER_SIMPLE].publisherId;
  }
  // 每次切换用户重新获取当前选中人的comment 和 caption信息
  if (!caption) {
    caption = await getUserContent({ type: "caption", publisherId });
  }
  if (!comment) {
    comment = await getUserContent({ type: "comment", publisherId });
  }
  const list = { caption, comment, publisherId };
  let storeData = _.cloneDeep(store.getters[PUBLISHER_CAPTION_COMMENT_LIST]);
  // 兼容所需如果发现是对象则转成数组
  if (!Array.isArray(storeData)) {
    storeData = [];
  }
  let publisherDataIndex = storeData.findIndex(
    (d) => d.publisherId === publisherId
  );
  if (publisherDataIndex !== -1) {
    storeData[publisherDataIndex] = list;
  } else {
    storeData.push(list);
  }
  store.commit(PUBLISHER_CAPTION_COMMENT_LIST, storeData);
}

/**
 * 获取随机的caption 和 comment
 * @param type bulk schedule repost drag
 * @param caption 指定的caption
 * @param comment 指定的comment
 * @returns {*}
 */
export function getCaptionComment({ type, caption, comment }) {
  let resultText = { caption: "", firstComment: "" };
  // 获取当前登录人权限
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  const defaultCaption = currentPublisher.defaultCaption;
  const defaultComment = currentPublisher.defaultComment;
  // 获取caption 和 comment中的#数量
  const list = store.getters[CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE];
  if (list) {
    // 获取所有default
    let captionList = list.caption.filter(
      (i) => i.is_default && i.is_default_on
    );
    let commentList = list.comment.filter(
      (i) => i.is_default && i.is_default_on
    );
    if (!defaultCaption.open || !defaultCaption[type]) {
      // 如果每开全局开关 或者对应权限的小开关每开相当于没设置
      captionList = [];
    }
    if (!defaultComment.open || !defaultComment[type]) {
      // 如果每开全局开关 或者对应权限的小开关每开相当于没设置
      commentList = [];
    }
    // 如果都没有设置则直接都返回空字符串即可
    if ((captionList.length === commentList.length) === 0) {
      return resultText;
    }
    // 如果没有则默认给一个空的好进行配对
    if (captionList.length === 0) {
      captionList.push({ content: "" });
    }
    if (commentList.length === 0) {
      commentList.push({ content: "" });
    }
    // 判断如果指定comment caption则
    if (caption !== undefined) {
      captionList = [{ content: caption }];
    }
    if (comment !== undefined) {
      commentList = [{ content: comment }];
    }
    captionList.forEach((item) => {
      item.size = [...item.content].filter((v) => v === "#").length;
    });
    commentList.forEach((item) => {
      item.size = [...item.content].filter((v) => v === "#").length;
    });
    // 计算comment caption所有组合
    const result = [];
    captionList.forEach((caption) => {
      commentList.forEach((comment) => {
        if (caption.size + comment.size <= 30) {
          result.push({
            firstComment: comment.content,
            caption: caption.content,
          });
        }
      });
    });
    if (result.length > 0) {
      const random = randomNum(0, result.length - 1);
      resultText = result[random];
    } else {
      // 如果没有找到则说明所有组合#都大于30 那么就随便选取
      if (captionList.length > 0) {
        const random = randomNum(0, captionList.length - 1);
        resultText.caption = captionList[random].content;
      }
      if (commentList.length > 0) {
        const random = randomNum(0, commentList.length - 1);
        resultText.firstComment = commentList[random].content;
      }
    }
  }
  return resultText;
}

/**
 * 获取saved中的caption信息
 * @param info saved信息
 * @param caption caption
 * @returns {*}
 */
export function getSavedCaption({ username, caption, defaultCaption = "" }) {
  // 获取当前选中用户的repost类型
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  const repostCaptionChoice = currentPublisher.repostCaptionChoice;
  const repostContentPosition = currentPublisher.repostContentPosition;
  let result = "";
  if (repostCaptionChoice === 0) {
    result = `#Repost @${username}\n---`;
  } else if (repostCaptionChoice === 1) {
    result = `${caption}\n---`;
  } else if (repostCaptionChoice === 2) {
    result = `#Repost @${username}\n---\n${caption}\n---`;
  } else if (repostCaptionChoice === 3) {
    result = ``;
  }
  if (defaultCaption) {
    if (repostCaptionChoice !== 3) {
      // 判断当前repoost加位置
      if (repostContentPosition === 2) {
        result = `${defaultCaption}\n---\n${result}`;
      } else {
        result += `\n${defaultCaption}`;
      }
    } else {
      result = defaultCaption;
    }
  }
  return result;
}
